// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://api.baeckereizimmer.de/api/',//'https://api.broetchenbote-online.de/api/'
  BASE_URL: 'https://api.baeckereizimmer.de', //'https://api.broetchenbote-online.de'

  DEFAULT_LANG: 'de',
  APP_VERSION: '1.0.9', // change app version to force clear cache
  GOOGLE_COUNTRIES: ["de"], //for google address
  GOOGLE_LOGIN_WEB_CLIENT_ID: '65878389371-fevipp0727iamaaimgfrtqtbo20hcnhv0.apps.googleusercontent.com',
  FACEBOOK_LOGIN_APP_ID: '10322122325652334',
  // theme configuration
  DEFAULT_PRIMARY_COLOR: '#cc1fb5',
  DEFAULT_PRIMARY_TEXT_COLOR: '#cc8a1f',
  // LAST_MADE_CHANGE:'Baeckereizimmer version init',
  // LAST_MADE_CHANGE:'Baeckereizimmer theme updated by praharsha and minor issue fixed in new feature',
  // LAST_MADE_CHANGE:'drop location select ui changed',
  // LAST_MADE_CHANGE: '1.0.3 : Delivery cost by area and other changes implemented for app side',
  // LAST_MADE_CHANGE: '1.0.4 : Isuru made some changes',
  // LAST_MADE_CHANGE: '1.0.5 : Fix google auto complete input field issue in address select modal, new links for FAQ and Bestellanleitung, some other minor changes',
  // LAST_MADE_CHANGE: '1.0.6 : Language key issue fixed in menu category availability check message',
  // LAST_MADE_CHANGE: '1.0.7 : Special order after completing payment with stripe or paypal not redirecting to ordersummary issue fixed, selectable start date set to tomorrow',
  // LAST_MADE_CHANGE: '1.0.8 : Calculation shows NaN issue fixed for customizable dishes',
  LAST_MADE_CHANGE: '1.0.9 : In App browser closes when there is return text in PayPal url issue fixed',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
